import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { SemiBold } from '../../components/UI/Text';
import TextField from '../../components/UI/TextField';
import Button from '../../components/UI/Button';
import { userApi } from '../../api/user';

const Container = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 50px;
`;

const FieldContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export default function FindPw() {
	const [email, setEmail] = React.useState('');
	const [id, setId] = React.useState('');
	const navigate = useNavigate();

	const hadnleSubmit = (e) => {
		e.preventDefault();
		userApi.findUserPw({ email, id })
		.then((response) => {
			navigate('/popUp/reset-pw/result', { state: { tempPw: response.password } });
		})
		.catch((error) => {
			alert('비밀번호를 재설정할 수 없습니다. 입력하신 정보를 다시 확인해 주세요.');
		});
	};

  	return (
		<Container>
			<SemiBold size="24px">이메일과 아이디를 입력하세요.</SemiBold>
			<FieldContainer>
				<TextField type="text" $placeholder="이메일" onChange={(e) => setEmail(e.target.value)}/>
				<TextField type="text" $placeholder="아이디" onChange={(e) => setId(e.target.value)}/>
			</FieldContainer>
			<Button buttonText="찾기" width="100%" height="60px" onClick={ hadnleSubmit }/>
		</Container>
  	)
}
